import { useTranslation } from 'react-i18next';

function Links({ links }) {
    const { t } = useTranslation();

    return (
        <div className="links has-background-light radius flow">
            <h2 className="is-family-secondary has-text-primary is-uppercase is-size-3">
                {t('webs y recursos en linea')}
            </h2>
            <div className="py-5">
                <ul className="list-reset is-flex is-flex-direction-column gap-4">
                    {links &&
                        links.length > 0 &&
                        links.map((item, index) => {
                            if (!item?.title || !item?.iri) return;

                            return (
                                <li key={'link-' + (item.id || index)}>
                                    <div className="has-background-white radius full-link">
                                        <div className="link-item flow">
                                            <p className="is-size-5">{item.title}</p>
                                            <p className="is-size-6 has-text-weight-light">
                                                <a
                                                    href={item.iri}
                                                    className="link-dn"
                                                    target="_blank"
                                                >
                                                    {item.iri
                                                        .replace('https://', '')
                                                        .replace('http://', '')
                                                        .replace('www.', '')}
                                                </a>
                                            </p>
                                        </div>
                                    </div>
                                </li>
                            );
                        })}
                </ul>
            </div>
        </div>
    );
}

export default Links;
